import { Tab } from "@headlessui/react";
import React from "react";

import BasicList from "./basic-list";
import ReactList from "./react-list";
import VueList from "./vue-list";

const Tabs = ({ activeTab, setActiveTab }) => {
  return (
    <Tab.Group selectedIndex={activeTab} onChange={setActiveTab}>
      <Tab.List className="w-full flex items-start border-t border-slate-200">
        <Tab
          className={`group w-1/3 mr-4 text-left border-t-2 ${
            activeTab === 0
              ? "border-emerald-500"
              : "border-transparent group-hover:text-emerald-500"
          }`}
        >
          <div className="py-8 pr-4">
            <h3
              className={`font-semibold text-base ${
                activeTab === 0
                  ? "text-emerald-500"
                  : "text-slate-700 group-hover:text-emerald-500"
              }`}
            >
              Basic Templates
            </h3>
            <p className="text-sm mt-3 text-slate-600 hidden sm:block">
              Built with vanilla HTML, CSS, and JS, these templates are the
              simplest to get started with.
            </p>
          </div>
        </Tab>
        <Tab
          className={`group w-1/3 mr-4 text-left border-t-2 ${
            activeTab === 1
              ? "border-emerald-500"
              : "border-transparent group-hover:text-emerald-500"
          }`}
        >
          <div className="py-8 pr-4">
            <h3
              className={`font-semibold text-base ${
                activeTab === 1
                  ? "text-emerald-500"
                  : "text-slate-700 group-hover:text-emerald-500"
              }`}
            >
              React Templates
            </h3>
            <p className="text-sm mt-3 text-slate-600 hidden sm:block">
              Built with React (and optionally TypeScript) and includes
              additional environment setup such as testing and tooling
            </p>
          </div>
        </Tab>
        <Tab
          className={`group w-1/3 mr-4 text-left border-t-2 ${
            activeTab === 2
              ? "border-emerald-500"
              : "border-transparent group-hover:text-emerald-500"
          }`}
        >
          <div className="py-8 pr-4">
            <h3
              className={`font-semibold text-base ${
                activeTab === 2
                  ? "text-emerald-500"
                  : "text-slate-700 group-hover:text-emerald-500"
              }`}
            >
              Vue Templates
            </h3>
            <p className="text-sm mt-3 text-slate-600 hidden sm:block">
              Built with Vue and includes additional environment setup such as
              testing and tooling
            </p>
          </div>
        </Tab>
      </Tab.List>
      <Tab.Panels>
        <Tab.Panel>
          <BasicList />
        </Tab.Panel>
        <Tab.Panel>
          <ReactList />
        </Tab.Panel>
        <Tab.Panel>
          <VueList />
        </Tab.Panel>
      </Tab.Panels>
    </Tab.Group>
  );
};

export default Tabs;
